export const envConfig = {
  preezieScriptUrl: process.env.PREEZIE_SCRIPT_URL,
};
